import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { NgxLoadingModule } from "ngx-loading";
import { TranslateModule } from "@ngx-translate/core";
import { CKEditorModule } from "ckeditor4-angular";
import { FuseSharedModule } from "@fuse/shared.module";
import { PropertyEditComponent } from "./property-edit.component";
import { GooglePlaceModule } from "@yuvarajv/ngx-google-places-autocomplete";
import { NgxMaskDirective, NgxMaskPipe } from "ngx-mask";

const routes = [
    {
        path: "edit-property/:propertyId",
        component: PropertyEditComponent,
    },
];

@NgModule({
    declarations: [PropertyEditComponent],
    imports: [
        RouterModule.forChild(routes),
        GooglePlaceModule,
        TranslateModule,
        FuseSharedModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatPaginatorModule,
        MatIconModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDatepickerModule,
        MatSlideToggleModule,
        CKEditorModule,
        NgxLoadingModule,
        NgxMaskDirective,
        NgxMaskPipe
    ],
    exports: [PropertyEditComponent],
})
export class PropertyEditModule {}
